/**
 * @fileOverView
 * @description Org Member row: name, status, developer portal toggle, remove.
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var OrgMemberTemplate = require('../../templates/widgets/orgmembertemplate.html');
var app = require('ampersand-app');
var dialog = require('../../lib/dialog');

var OrgMemberView = AmpersandView.extend({
    template: OrgMemberTemplate,

    bindings: {
        "model.displayName": {
            type: 'text',
            hook: 'name'
        },
        "model.statusDisplay" : {
            type: "innerHTML",
            hook: "status"
        },
        "model.developer_access" : {
            type: "booleanAttribute",
            name: "checked",
            hook: "dev-access"
        }
    },

    events: {
        "change [data-hook=dev-access]" : "toggleDeveloperAccess",
        "click [data-hook=remove]" : "removeMember"
    },

    toggleDeveloperAccess: async function(e){
        var target = e.target;
        var granting = target.checked;

        if(granting && !await dialog.confirm('Give ' + this.model.displayName + ' developer portal access? They will be able to see and change this account\'s API key, OAuth credentials, and webhooks.', {title: 'Developer portal access', okText: 'Give access'})){
            target.checked = false;
            return;
        }

        this.model.save({developer_access: granting}, {
            patch: true,
            wait: true,
            error: function(){
                target.checked = !granting;
                dialog.alert('error updating developer access');
            }
        });
    },

    removeMember: async function(){
        //a pending invitee may have no account name yet
        var msg = this.model.status=="invited"
            ? "Revoke invitation for " + (this.model.email || this.model.displayName) + "?"
            : "Remove " + this.model.displayName + " as a manager? They will lose manager access and their subscriptions to your private vybits.";

        if(this.model.developer_access){
            msg += "\n\nThey had developer portal access. Any API key or secret they saw remains valid, so rotate them from the developer portal if that matters.";
        }
        if(!await dialog.confirm(msg, {okText: this.model.status=="invited" ? 'Revoke' : 'Remove manager', danger: true})) return;

        //wait:true so the seat is released only once the server confirms
        this.model.destroy({
            wait: true,
            success: function(){
                if(!app.orgMembers) return;
                var opts = {};
                if(app.orgMembers.searchQuery) opts.data = {query: encodeURI(app.orgMembers.searchQuery)};
                app.orgMembers.fetch(opts);
            },
            error: function(){
                dialog.alert('error removing manager');
                if(app.orgMembers) app.orgMembers.fetch();
            }
        });
    }

});

module.exports = OrgMemberView;
